import { EyeDropperIcon } from '@heroicons/react/24/solid';
import React, { useState } from 'react';
import { TwitterPicker, ChromePicker } from 'react-color';

const ColorPicker = ({ value, onChange }) => {
  const [showTwitterPicker, setShowTwitterPicker] = useState(false);
  const [showChromePicker, setShowChromePicker] = useState(false);
  const twitterColors = ['#000000', '#FFFFFF', '#808080', '#FF0000', '#00FF00', '#0000FF', '#FFFF00', '#800080', '#FFC0CB', '#00FFFF'];

  const handleTwitterColorChange = (color) => {
    onChange(color.hex);
    setShowTwitterPicker(false);
  };

  const handleChromeColorChange = (color) => {
    onChange(color.hex);
  };

  return (
    <div className="relative">
      <div className="flex gap-2 mb-2">
        <div className="w-10 h-10 rounded border shadow-sm cursor-pointer" style={{ backgroundColor: value || "#FFFFFF" }}
          onClick={() => {
            setShowTwitterPicker(!showTwitterPicker);
            setShowChromePicker(false);
          }} />
        <input type="text" value={value} onChange={(e) => onChange(e.target.value)} className="flex-1 focus:ring-orange-600 focus:border-orange-600 bg-gray-50 border text-black text-sm rounded-lg p-2.5" placeholder="#000000" />
        <button onClick={() => {
            setShowChromePicker(!showChromePicker);
            setShowTwitterPicker(false);
          }} className="px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors">
          <EyeDropperIcon className="size-5" />
        </button>
      </div>

      {showTwitterPicker && (
        <div className="fixed inset-0 z-[70]">
          <div className="fixed inset-0" onClick={() => setShowTwitterPicker(false)} />
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <TwitterPicker color={value} colors={twitterColors} onChange={handleTwitterColorChange} triangle="hide" />
          </div>
        </div>
      )}

      {showChromePicker && (
        <div className="fixed inset-0 z-[70]">
          <div className="fixed inset-0" onClick={() => setShowChromePicker(false)} />
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <ChromePicker color={value} onChange={handleChromeColorChange} disableAlpha={false} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorPicker;